import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate, Link } from 'react-router-dom'
import { Container, Form, Button, Alert } from 'react-bootstrap'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { signIn } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!email || !password) {
      return setError('Please fill in all fields')
    }

    try {
      setError('')
      setLoading(true)
      const { error } = await signIn(email, password)

      if (error) {
        setError(error.message)
      } else {
        navigate('/')
      }
    } catch (error) {
      setError('Failed to sign in')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      background: '#FBFBFC',
      minHeight: '100vh',
      fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif"
    }}>
      <style>{`
        .auth-card {
          border: 1px solid #eef2f6;
          background: #fff;
          border-radius: 1.2rem;
          box-shadow: 0 10px 30px 0 rgba(60,80,120,0.08);
        }

        .auth-title {
          font-size: 2rem;
          font-weight: 700;
          color: #1A2940;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }

        .auth-badge {
          background: #EEF4FB;
          border: 1px solid #93c5fd;
          color: #60a5fa;
          text-transform: uppercase;
          font-weight: 600;
          letter-spacing: 0.08em;
          font-size: 11px;
          border-radius: 0.5rem;
          padding: 0.25em 0.6em;
          display: inline-block;
        }

        .auth-input {
          border: 1px solid #eef2f6;
          border-radius: 0.5rem;
          padding: 0.75rem 1rem;
          font-size: 0.95rem;
          transition: all 0.2s ease;
        }

        .auth-input:focus {
          border-color: #93c5fd;
          box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.1);
          outline: none;
        }

        .auth-label {
          font-weight: 600;
          color: #1E2433;
          font-size: 0.9rem;
          margin-bottom: 0.5rem;
        }

        .auth-button {
          background: #1A2940;
          border: none;
          border-radius: 0.5rem;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          font-size: 1rem;
          transition: all 0.2s ease;
        }

        .auth-button:hover:not(:disabled) {
          background: #2a3950;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(26, 41, 64, 0.2);
        }

        .auth-button:disabled {
          background: #64748b;
          cursor: not-allowed;
        }

        .auth-link {
          color: #60a5fa;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.2s ease;
        }

        .auth-link:hover {
          color: #1A2940;
          text-decoration: underline;
        }

        .auth-alert {
          background: #FEE;
          border: 1px solid #FCC;
          border-radius: 0.5rem;
          padding: 0.75rem 1rem;
          color: #C33;
          font-size: 0.9rem;
        }
      `}</style>

      <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', paddingTop: '2rem', paddingBottom: '2rem' }}>
        <div className="w-100" style={{ maxWidth: '440px' }}>
          <div className="auth-card p-4 p-md-5">
            <div className="text-center mb-4">
              <h2 className="auth-title">Log In</h2>
              <p style={{ color: '#64748b', fontSize: '0.95rem' }}>
                Welcome back to MintDB
              </p>
            </div>

            {error && (
              <div className="auth-alert mb-3">
                {error}
              </div>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label className="auth-label">Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="auth-input"
                  placeholder="your.email@example.com"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="auth-label">Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="auth-input"
                  placeholder="Enter your password"
                />
              </Form.Group>

              <div className="text-end mb-4">
                <Link to="/forgot-password" className="auth-link" style={{ fontSize: '0.85rem' }}>
                  Forgot password?
                </Link>
              </div>

              <Button
                disabled={loading}
                className="w-100 auth-button"
                type="submit"
              >
                {loading ? 'Signing in...' : 'Log In'}
              </Button>
            </Form>
          </div>

          <div className="w-100 text-center mt-3" style={{ color: '#64748b' }}>
            Need an account? <Link to="/register" className="auth-link">Sign Up</Link>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Login